import React from "react";
import { apiGet } from "../api";

export const UserInfoContext = React.createContext([]);

const UnnamedComponent = (props) => {
  const [userInfo, setUserInfo] = React.useState();
  React.useEffect(() => {
    (async () => {
      const { parsedResponse } = await apiGet("/api/v1/users/info");
      setUserInfo(parsedResponse);
    })();
  }, []);

  const contextValue = React.useMemo(() => ({ ...userInfo }), [userInfo]);
  return (
    <UserInfoContext value={contextValue}>{props.children}</UserInfoContext>
  );
};

export default UnnamedComponent;
